<script setup lang="ts">
import {
  RadioGroupIndicator,
  RadioGroupItem,
  type RadioGroupItemProps,
} from 'radix-vue'
import { Circle } from 'lucide-vue-next'
import { cn } from '../../../lib/utils'

const props = defineProps<RadioGroupItemProps & { class?: string }>()
</script>

<template>
  <RadioGroupItem
    v-bind="props"
    :class="
      cn(
        'aspect-square h-[16px] w-[16px] rounded-full cursor-pointer flex justify-center items-center border border-slate-200 border-slate-900 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:border-slate-50',
        props.class,
      )
    "
    :name="props.name || props.id"
  >
    <RadioGroupIndicator
      :class="cn('flex items-center justify-center', props.class)"
    >
      <Circle class="w-[10px] h-[10px] text-current fill-current" />
    </RadioGroupIndicator>
  </RadioGroupItem>
</template>
